import { postForm } from '@si/utils';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

import { queryKeys } from './queryKeys';

export function useUploadProfilePicture() {
  const queryClient = useQueryClient();

  const { mutate, error, isPending, isSuccess, reset } = useMutation({
    mutationFn: (file: Blob) => {
      const formData = new FormData();
      formData.append('file', file, 'profile-picture.jpg');
      return postForm({ url: '/users/current/profile-picture', body: formData });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.getUser('current') });
      queryClient.invalidateQueries({ queryKey: queryKeys.getProfilePicture() });
    },
  });

  const uploadProfilePicture = useCallback((file: Blob) => mutate(file), [mutate]);

  return {
    uploadProfilePicture,
    error,
    isPending,
    isSuccess,
    reset,
  };
}
